<template>
    <div class="row">
        <div class="appeals col-12" v-if="clientTimezone">
            <div class="row mt-2 mb-3 mt-md-0">
                <div class="col-12 col-lg-7">
                    <div class="d-flex h-100  flex-wrap flex-sm-nowrap align-items-end justify-content-between justify-content-sm-start">
                        <div class="datepicker">
                            <span class="datepicker__label">
                                 {{'appeals.date_start' | trans }}
                            </span>

                            <v-date-picker
                                    v-model='rangeDateStart'
                                    :formats='formats'
                                    title-position="left"
                                    :input-props='{ readonly: true }'
                                    :max-date='new Date()'
                                    name="rangeDateStart"
                                    v-validate="'required|check-period'"
                                    data-vv-validate-on="none">
                            </v-date-picker>

                            <mdc-icon icon="date_range"></mdc-icon>
                        </div>

                        <div class="datepicker">
                            <span class="datepicker__label">
                                 {{'appeals.date_end' | trans }}
                            </span>

                            <v-date-picker
                                    v-model='rangeDateEnd'
                                    :formats='formats'
                                    title-position="left"
                                    :input-props='{ readonly: true }'
                                    :max-date='new Date()'
                                    :min-date="rangeDateStart">
                            </v-date-picker>

                            <mdc-icon icon="date_range"></mdc-icon>
                        </div>

                        <button type="button"
                                class="btn btn-lightblue mt-3 mt-sm-0 mb-2 mb-sm-0" raised
                                @click.prevent="onSendRequest()">
                            {{'appeals.buttons.apply' | trans }}

                        </button>
                    </div>
                </div>

                <div class="col-12 col-lg-5 d-md-none d-lg-block" v-if="!isMobile">
                    <div class="d-flex h-100  align-items-end justify-content-end">
                        <button type="button" class="btn btn-light mr-2" raised
                                @click.prevent="onEditBtnClick">
                            {{'appeals.typical_appeals' | trans }}
                        </button>

                        <mdc-button v-if="!isMensurationForbidden" class="button-primary" raised
                                    @click.prevent="onShowModalBtnClick">
                            {{'appeals.buttons.write_appeal' | trans }}

                        </mdc-button>
                    </div>
                </div>

                <div class="col-12">
                    <span class="description-row" :class="{'invalid-feedback': errors.has('rangeDateStart')}">{{'report.description_max_period' | trans }}</span>
                </div>
            </div>

            <div class="row">
                <div class="col-12" v-if="!isLoaded">
                    <loader class="table-loader"
                            messages="home.labels.loading_message_table"></loader>
                </div>
                <div class="col-12">
                    <div class="appeals-item" v-for="appeal in appeals" :key="appeals.id"
                         v-if="!isEmptyAppeals && isLoaded">
                        <div class="appeals-item__header">
                            <span>{{toLocaleDateYear(Object.keys(appeal)[0])}}</span>
                        </div>

                        <div class="appeals-list">
                            <div v-for="items in appeal">
                                <div v-for="(typicalAppeal, index) in items" :key="index"
                                     class="radio-btn">
                                    {{typicalAppeal.text}} ({{typicalAppeal.count}})
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="text-center" v-if="isEmptyAppeals && isLoaded">
                <h5>{{'appeals.no_data' | trans }}</h5>
            </div>

            <div class="row mt-2 mt-md-0">
                <div class="col-sm-12 col-md-5">
                    <nav class="nav justify-content-center justify-content-md-start"
                         v-if="!isEmptyAppeals && paginate.lastPage > 1">
                        <paginate :page-count="paginate.lastPage"
                                  :page-range="paginate.pageRange"
                                  :margin-pages="paginate.marginPages"
                                  :force-page="paginate.forcePage"
                                  :click-handler="onPaginationClick"
                                  :container-class="'pagination pagination-sm'"
                                  :page-class="'page-item'"
                                  :page-link-class="'page-link'">
                            <span slot="prevContent" class="page-link">&laquo;</span>
                            <span slot="nextContent" class="page-link">&raquo;</span>
                        </paginate>
                    </nav>
                </div>

                <div class="col-sm-12 col-md-7 text-right d-lg-none">
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <button type="button" class="btn btn-light mb-2 mb-sm-0" raised
                                    @click.prevent="onEditBtnClick">
                                {{'appeals.typical_appeals' | trans }}

                            </button>
                        </div>
                        <div class="col-12 col-sm-6" v-if="!isMensurationForbidden"
                        >
                            <mdc-button class="col-12 button-primary" raised
                                        @click.prevent="onShowModalBtnClick">
                                {{'appeals.buttons.write_appeal' | trans }}


                            </mdc-button>
                        </div>
                    </div>
                </div>
            </div>

            <appeals-add-modal :visible="isModalVisible"
                               :clientId="clientId"
                               v-on:close="onModalClose"
                               v-on:cancel="onModalCancel">
            </appeals-add-modal>

            <edit-typical-appeals-modal :visible="isEditModalVisible"
                                        :clientId="clientId"
                                        v-on:close="onModalClose"
                                        v-on:cancel="onModalCancel">
            </edit-typical-appeals-modal>

            <div class="row">
                <div class="col-12 mb-4 mt-4" v-if="measurements">

                    <bar-chart :linedatasets="lineChartDataset"
                               :bardatasets="barChartDataset"
                               :scale-label-x= "'report.day_session' | trans"
                               :scale-label-y= "'appeals.appeals_count' | trans"
                               :height=null
                               :width=null
                               v-bind:show-legend="true"/>
                    <h4 class="chart__title mb-3">{{'appeals.appeals_chart' | trans}}</h4>
                </div>

            </div>

        </div>

        <div class="col-12" v-else>
            <loader class="table-loader"
                    messages="home.labels.loading_message_table">
            </loader>
        </div>
    </div>
</template>

<script>
  import apiAppeals from '../api/appeals';
  import appealsAddModal from './AddModal';
  import editTypicalAppealsModal from './editTypicalAppealsModal.vue';
  import {pagination} from '../../../common/mixins/pagination';
  import {showModal} from '../../../common/mixins/showModal';
  import {mapActions, mapGetters, mapState} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import isEmpty from 'lodash/isEmpty';
  import cloneDeep from 'lodash/cloneDeep';
  import Constants from '../Constants';
  import {
    BarChart,
    BarChartDataset,
    LineChartDataset,
  } from '../../../common/chart';
  import forEach from 'lodash/forEach';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import timezone from 'moment-timezone';
  import {Validator} from 'vee-validate';
  import Auth from '../../../common/auth/Manager';

  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      },
      'clientTimezone': {
        type: [String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        apiUrl: 'appeals/statistics/',
        isModalVisible: false,
        isEditModalVisible: false,
        rangeDateStart: new Date(),
        rangeDateEnd: new Date(),
        measurements: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
      };
    },
    mixins: [pagination, showModal],
    components: {
      Loader, appealsAddModal, editTypicalAppealsModal, BarChart,
    },
    computed: {
      ...mapState('appeals', [
        'appeals',
        'isLoaded',
        'paginateData',
        'isAdded',
      ]),
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isMensurationForbidden',
      ]),
      isEmptyAppeals: function() {
        return isEmpty(this.appeals);
      },
      lineChartDataset() {
        return this.fetchDatasetForChart();
      },
      barChartDataset() {
        return this.fetchBarDatasetForChart();
      },
      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).unix() + (Math.abs(this.rangeDateEnd.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).unix() + (Math.abs(this.rangeDateEnd.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },
    },
    created() {
      Validator.extend('check-period', {
        getMessage: attribute => lang.get('report.description_max_period', {attribute}),
        validate: () => {
          let date = new Date(this.rangeDateStart.getFullYear(),
            (this.rangeDateStart.getMonth() + 4),
            this.rangeDateStart.getDate(),
            this.rangeDateEnd.getHours(),
            this.rangeDateEnd.getMinutes(),
            this.rangeDateEnd.getSeconds(),
            this.rangeDateEnd.getMilliseconds()
          );
          return this.rangeDateEnd.getTime() <= date.getTime();
        }
      });
      let initialPage = 1;

      if(!!localStorage.currentPage && localStorage.currentPage != 1){

        if(localStorage.getItem("currentPageHeader") === 'appeals') {
          initialPage = localStorage.getItem("currentPage");
        }
        let rangeDateStart  = localStorage.getItem("rangeDateStart");
        let rangeDateEnd  = localStorage.getItem("rangeDateEnd");
        if(rangeDateStart){
          this.rangeDateStart = moment(rangeDateStart)._d;
        }
        if(rangeDateEnd){
          this.rangeDateEnd = moment(rangeDateEnd)._d;
        }
        this.clientId = localStorage.getItem('clientId') ? localStorage.getItem('clientId') : Auth.getUserInfo().id || this.route.params.clientId;
        this.paginate.page = initialPage;
        this.onSendRequest();


      } else {

        if (this.clientTimezone) {
          this.setDate();
        }

      }
    },


    beforeDestroy(){
      localStorage.removeItem('currentPage');
      localStorage.removeItem('rangeDateStart');
      localStorage.removeItem('rangeDateEnd');
      localStorage.removeItem('clientId');
    },

    methods: {
      ...mapActions('appeals', [
        'setAppeals',
        'setTypesAppeals',
        'setCurrentPage',
        'setIsAdded',
      ]),
      setDate() {
        let clientDateStart = moment().tz(this.clientTimezone).subtract(Constants.COUNT_DAY, 'days').add(-(moment().utcOffset()), 'm');
        let clientDateEnd = moment().tz(this.clientTimezone).add(-(moment().utcOffset()), 'm');

        this.rangeDateStart = clientDateStart._d;
        this.rangeDateEnd = clientDateEnd._d;

        this.onSendRequest();
      },
      onPaginationClick(pageNum) {
        localStorage.setItem('currentPage', pageNum);
        localStorage.setItem('currentPageHeader', 'appeals');
        localStorage.setItem('rangeDateStart', this.rangeDateStart);
        localStorage.setItem('rangeDateEnd', this.rangeDateEnd);
        localStorage.setItem('clientId', this.clientId);

        this.setCurrentPage(pageNum);
        this.getPageAppeals(
            this.clientId,
            this.paginate.perPage,
            pageNum,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp);
      },
      async onSendRequest() {

        let result = await this.$validator.validateAll();
        if (!result) {
          return;
        }
        this.getPageAppeals(
            this.clientId,
            this.paginate.perPage,
            this.paginate.page,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp,
        );
        this.fetchMeasurement(this.clientId);
      },

      getPageAppeals: async function(clientId, perPage, page, startDate, endDate) {
        await this.setAppeals({clientId, perPage, page, startDate, endDate});
        this.onPaginationBtnClick(page);
        this.setIsAdded(false);
      },
      onModalCancel() {
        this.isModalVisible = false;
        this.isEditModalVisible = false;
      },
      onModalClose() {
        this.isModalVisible = false;
        this.isEditModalVisible = false;
      },
      onEditBtnClick() {
        this.isEditModalVisible = true;
      },
      fetchMeasurement: async function() {
        try {
          let response = await apiAppeals.getCountAppeals(
              this.clientId,
              this.rangeDateStartTimestamp,
              this.rangeDateEndTimestamp,
          );

          this.measurements = response.data.data;

        } catch (error) {
          console.dir(error);
        }
      },
      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM')
      },
      toLocaleDateYear: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY')
      },
      fetchDatasetForChart() {
        let data = [];
        let i = 0;
        let label = lang.get('appeals.avarage_appeals_perhour');
        forEach(this.measurements, (item) => {
          data.push(
              {
                x: i,
                y: item.perHourCount,
              },
          );
          i++;
        });

        return new LineChartDataset({
          data, label,
        });

      },
      fetchBarDatasetForChart() {
        let data = [];
        let i = 0;
        let label = lang.get('appeals.total_appeals_perday');
        let labels = [];
        forEach(this.measurements, (item) => {
          data.push(
              {
                x: i,
                y: item.totalCount,
              },
          );
          i++;
          labels.push(this.toLocaleDate(item.dateRange.end));

        });

        return new BarChartDataset({data, label, labels});
      },
    },
    watch: {
      paginateData() {
        this.setPaginate(this.paginateData);
      },
      isAdded() {
        if (this.isAdded) {
          this.onSendRequest();
        }
      },
      rangeDateStart(oldValue, newValue) {
        /*let rangeDays = Constants.MILLISECONDS * Constants.SECONDS *
            Constants.MINUTES * Constants.HOURS * Constants.COUNT_DAY;
        if (!oldValue) {
          this.rangeDateStart = newValue
        }
        let myDate = cloneDeep(this.rangeDateStart);
        let newDate = new Date(myDate.getTime() + rangeDays);

        if (newDate.getTime() / Constants.MILLISECONDS > moment.tz(new Date(), this.clientTimezone).utcOffset(0, true).unix()) {
          this.rangeDateEnd = moment().tz(this.clientTimezone).add(-(moment().utcOffset()), 'm')._d;
        }
        else {
          this.rangeDateEnd = newDate;
        }*/
      },
      clientTimezone() {
        if (this.clientTimezone) {
          this.setDate();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/appeals/components/AppealsList.vue